export const INCLUDE_ON_MENU_LABEL = "Include on Menu";
